import React from 'react'
import { Link } from 'gatsby'
import { GridLink as GridLinkType } from 'types'

interface PropsType {
    dataLink?: GridLinkType
}

const GridLink = ({dataLink}: PropsType) => {

    return (
        <Link to={dataLink?.link ? dataLink?.link : ""} id={"grid-link-wrapper" + dataLink?.id} 
            className={"grid-link d-flex" + (dataLink?.link ? " cursor-pointer" : "")}>
            <div className="position-relative thumb w-100">
                <div className="text-container d-table position-absolute w-100 h-100">
                    <div className="centra d-table-cell w-100 h-100">
                        <h1>{dataLink?.title}</h1>
                    </div>
                </div>
                <div className="shadow-banner position-absolute"></div>
                <div className="bg-thumb position-relative d-inline-block w-100" 
                     style={{backgroundImage: `url(${dataLink?.image})`}}></div>
            </div>
        </Link>
    )
}

export default GridLink